module.exports = __webpack_public_path__ + "img/share-twitter.5fe1c3a3.svg";